import { useQuery } from "@tanstack/react-query";
import { LEGAL_COMPLIANCE_QUERY_KEYS } from "@/features/legal/config/legal.config";
import { getPublicLegalDocuments } from "@/features/legal/services/legalCompliance.service";
import type { LegalDocument } from "@/features/legal/types/legalCompliance.type";

// Current notices (privacy, cookies, CSE notice), readable before login.
// A failure only hides the links: it must never block signing in.
export const usePublicLegalDocuments = () =>
  useQuery<LegalDocument[]>({
    queryKey: LEGAL_COMPLIANCE_QUERY_KEYS.publicDocuments(),
    queryFn: getPublicLegalDocuments,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
